import { createFileRoute } from '@tanstack/react-router'
import { ShiftCloseScreen } from '@/features/shift/shift-close-screen'

export const Route = createFileRoute('/_app/shift')({ component: ShiftCloseScreen })
